/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "522")




export interface API47776Req {
  
  /** 项目编号 */
  projectNo?: string;
  /** 项目名称 */
  name?: string;
  /** 项目logo图片url */
  logo?: string;
  /** 项目描述 */
  desc?: string;
  /** 项目级别：1:超S级2:S级3:A级4:B级 */
  level?: number;
  /** 项目负责人编号 */
  projectLeaderNo?: string;
  /** 项目阶段：1:成熟2:孵化3:筹备4:暂停5：完成 */
  growStatus?: number;
  /** 项目开始日期yyyy-MM-dd */
  projectStartDate?: any;
  /** 项目结束日期yyyy-MM-dd */
  projectEndDate?: any;
  /** 是否长期：0.非长期(默认)1.长期 */
  isLongTime?: number;
  /** 业务分类：1.基础业务2.创新业务3.投资业务 */
  businessType?: number;
  /** 类型：1.项目(默认)2.任务 */
  projectType?: number;
  /** 当前项目的主业务,默认0 */
  parentProjectNo?: string;
  /** 项目汇报提醒 ,ProjectReportRemindParam */
  projectReportRemindParam?: any;
  /** 启用状态：1.启用2.停用 */
  enableStatus?: number;
};



export type API47776Res = {};


// 47776 编辑项目-概述

export interface IUsePostAPI47776Return {
  /** 编辑项目-概述: 接口请求状态 */
  isAPI47776Loading: boolean;
  /** 编辑项目-概述: 接口请求返回数据 */
  dataAPI47776: API47776Res;
  /**  编辑项目-概述: 接口数据请求方法 */
  fetchAPI47776Data:  (inputs: API47776Req, config?: YWRequestConfig) => Promise<API47776Res>;
  /** 编辑项目-概述: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI47776 = ():IUsePostAPI47776Return => {
  let isMount = true;
  const [isAPI47776Loading, setIsAPI47776Loading] = useState(false);
  const [dataAPI47776, setDataAPI47776] = useState<API47776Res>({} as API47776Res);
  const requestUrl = `${basePath}/corp-admin/project/edit`;

  const fetchAPI47776Data = async (inputs: API47776Req, config?: YWRequestConfig): Promise<API47776Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API47776Req>) || {}) as API47776Req;
    
  
    if ( isMount ) {
      setIsAPI47776Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API47776Res>(`${basePath}/corp-admin/project/edit`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI47776(res || {} as API47776Res);
        setIsAPI47776Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI47776Loading(false);
      }
      return false as unknown as API47776Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI47776Loading,
    dataAPI47776,
    fetchAPI47776Data,
    requestUrl,
  }
}

